import { render, staticRenderFns } from "./BioTestingDashboardCard.vue?vue&type=template&id=7f9fada6&scoped=true"
import script from "./BioTestingDashboardCard.vue?vue&type=script&lang=js"
export * from "./BioTestingDashboardCard.vue?vue&type=script&lang=js"
import style0 from "./BioTestingDashboardCard.vue?vue&type=style&index=0&id=7f9fada6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9fada6",
  null
  
)

export default component.exports